import httpClient from "@/API/HttpClient";
import AuthClient from "@/API/AuthClient";

// Login
const login = (PhoneNumber) =>
  AuthClient.post(`api/verify_phone_number`, { PhoneNumber });
const verifyPhone = (params) =>
  AuthClient.post(`connect/token`, params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
// User
const getUser = () => httpClient.get(`Customer`);
const updateUser = (user) => httpClient.put(`Customer`, user);
const getFactorList = () => httpClient.get(`FactorTrack`);
const getFactorDetail = (id) => httpClient.get(`FactorById?Id=${id}`);

// Home
const getBanners = () => httpClient.get("Banners");
const getHome = () => httpClient.get("Home");
const getHomeCategory = (type = 0) =>
  httpClient.get(`HomeCategory?type=${type}`);

// Call Waiter
const getCallWaiterReasons = () => httpClient.get("CallWaiterReason");
const callWaiter = (tableno, message) =>
  httpClient.post(`CallWaiter?message=${message}&tableno=${tableno}`);

// Menu
const getMenu = () => httpClient.get(`Menu`);
const getSubMenu = (id) => httpClient.get(`Menu/${id}`);
const getFood = (id) => httpClient.get(`Food/${id}`);
const getSpecialCategory = (id) => httpClient.get(`specialCategory/${id}`);
const getMenuOnlyService = () => httpClient.get(`MenuOnlyService`);

// Factor
const submitFactor = (factor) => httpClient.post(`CreateFACTOR`, factor);
const getUnpaidFactors = (factor) => httpClient.get(`UnPaidFacor`, factor);
const getFinalFactor = (factor) => httpClient.post(`CheckOut`, factor);
const checkPaymentFactor = (factor, mab) =>
  httpClient.put(`CheckPaymentFactor?mab=${mab}`, factor);

// Payment
const payFactor = (id) => httpClient.post(`pay?factorid=${id}`);

//map
const convertToLocation = (ADDRESS) =>
  AuthClient.get(`https://api.neshan.org/v4/geocoding?address=${ADDRESS}`, {
    headers: {
      "Api-Key": "service.7027dcf0790e4949bce44804ffccff20",
    },
  });
const mapMatching = (latitude, longitude) => {
  const data = {
    path: `${latitude},${longitude}|${latitude},${longitude}`,
  };

  return AuthClient.post(`https://api.neshan.org/v3/map-matching`, data, {
    headers: {
      "Api-Key": "service.f251dbb445fa404eb4292e5128ae46a8",
    },
  });
};

export {
  login,
  verifyPhone,
  getHomeCategory,
  getSubMenu,
  getFood,
  getMenuOnlyService,
  getFinalFactor,
  getUnpaidFactors,
  submitFactor,
  callWaiter,
  getFactorDetail,
  payFactor,
  getUser,
  updateUser,
  getFactorList,
  getBanners,
  getHome,
  getCallWaiterReasons,
  getSpecialCategory,
  getMenu,
  checkPaymentFactor,
  convertToLocation,
  mapMatching,
};
